<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import messages from '@/locales/shipping/messages'

const { t, locale } = useI18n({
    useScope: 'global',
    messages: messages
});

</script>
<template>
    <div id="category_header">
        <img src="/img/about/background.jpg" alt="KaseFilters.fr" />
        <h1>{{ $t('shipping.title') }}</h1>
    </div>
    <div class="content">
        <template v-for="(block, index) in messages.fr.shipping.contents" :key="index">
            <h1 v-if="block.type === 'title'">{{ $t('shipping.contents.'+index+'.content') }}</h1>
            <h2 v-if="block.type === 'title2'">{{ $t('shipping.contents.'+index+'.content') }}</h2>
            <p v-else-if="block.type === 'paragraph'" v-html="$t('shipping.contents.'+index+'.content').replaceAll('\n','<br />')"></p>
            <div v-else-if="block.type === 'bold'"><b>{{ $t('shipping.contents.'+index+'.content') }}</b></div>
            <em v-else-if="block.type === 'italic'">{{ $t('shipping.contents.'+index+'.content') }}</em>
            <ul v-else-if="block.type === 'list' && block.variant!='ol'">
                <li v-for="(item, idx) in block.items" :key="idx">{{ $t('shipping.contents.'+index+'.items.'+idx) }}</li>
            </ul>
            <ol v-else-if="block.type === 'list' && block.variant==='ol'">
                <li v-for="(item, idx) in block.items" :key="idx">{{ $t('shipping.contents.'+index+'.items.'+idx) }}</li>
            </ol>
            <a v-else-if="block.type === 'email'" :href="'mailto:'+$t('shipping.contents.'+index+'.content')">{{ $t('shipping.contents.'+index+'.content') }}</a>
        </template>
    </div>
</template>
<style lang="scss" scoped>
#category_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 190px;
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 30px;
        font-weight: 700;
        line-height: 36.57px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    h2{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
}
    .row{
        flex-wrap: wrap;
    }
    h1, h2{
        margin-bottom: 10px;
    }
    div{
        margin-bottom: 10px;
    }
    p{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    ol, ul{
        margin-bottom: 10px;
        margin-top: 10px;
        margin-left: 20px;
    }
    @media only screen and (min-width : $responsive-point) {
        .row{
            flex-wrap: nowrap;
        }
    }
</style>
<route lang="yaml">
name: shipping
props: true
meta:
    title: Information de livraison KaseFilters France
    layout: default
    description: Quel mode de livraison, quel délai et quel coût pour votre commande KaseFilters
    middleware: guest
</route>